import {ValidationErrors} from '@angular/forms';

export class ValidationHelper
{
    public static getCustomValidatorResponse(errorKey: ValidationErrorTypes, message: string): ValidationErrors
    {
        return {[errorKey]: message};
    }
}

export type ValidationErrorTypes =
    'minlength'
    | 'maxlength'
    | 'pattern'
    | 'backendValidation'
    | 'required'
    | 'customValidation'
    | 'invalidMobileNumber'
    | 'invalidIdLength'
    | 'invalidIdNumber'
    | 'validateFSPNumber';
